<template>
  <div>
      <dashbar />
      <v-row class="">
          <v-col cols="12" xs="1" sm="1" md="1" lg="1" xl="1">
              <dashboard /> 
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6" class="mt-14">
             <v-card>
                 <v-img src="../assets/showcase.jpeg"></v-img>
             </v-card>
          </v-col>
          <v-spacer></v-spacer>
      </v-row>
  </div>
</template>

<script>
import Dashbar from '../components/Dashbar.vue'
import Dashboard from '../components/Dashboard.vue'
export default {
  components: { Dashboard, Dashbar },

}
</script>

<style>

</style>